import { render, staticRenderFns } from "./firmwareDetails.vue?vue&type=template&id=8b13e3a0&scoped=true"
import script from "./firmwareDetails.vue?vue&type=script&lang=js"
export * from "./firmwareDetails.vue?vue&type=script&lang=js"
import style0 from "./firmwareDetails.vue?vue&type=style&index=0&id=8b13e3a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b13e3a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b13e3a0')) {
      api.createRecord('8b13e3a0', component.options)
    } else {
      api.reload('8b13e3a0', component.options)
    }
    module.hot.accept("./firmwareDetails.vue?vue&type=template&id=8b13e3a0&scoped=true", function () {
      api.rerender('8b13e3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/firmwareDetails/firmwareDetails.vue"
export default component.exports